import { media, styled } from '@payright/web-components';
import { ReactNode } from 'react';

const Row = styled.li`
  display: flex;
  grid-template-columns: 1fr 1fr;
  padding: 0.5rem 0;
  justify-content: space-between;
  width: 100%;
  :not(:first-child) {
    border-top: 1px dashed ${(props) => props.theme.colours.grey.medium};
  }
`;
const LineTitle = styled.span`
  font-size: 0.75rem;
  font-weight: 500;
  color: ${(props) => props.theme.colours.blue.base};
  text-align: left;
  padding: 0.5rem 0;

  ${media.min.medium} {
    font-size: 0.875rem;
  }
`;

const LineValue = styled.span`
  font-size: 0.75rem;
  font-weight: 400;
  text-align: right;
  padding: 0.5rem 0;

  ${media.min.medium} {
    font-size: 0.875rem;
  }
`;

type ContractListLineProps = {
  title: ReactNode;
  value: ReactNode;
};

export const ContractListLine = ({ title, value }: ContractListLineProps) => {
  return (
    <Row>
      <LineTitle>{title}</LineTitle>
      <LineValue>{value}</LineValue>
    </Row>
  );
};
